const isoMap = {
  Afghanistan: {
    Code: "AF",
    Name: "Afghanistan",
  },
  "Åland Islands": {
    Code: "AX",
    Name: "Åland Islands",
  },
  Albania: {
    Code: "AL",
    Name: "Albania",
  },
  Algeria: {
    Code: "DZ",
    Name: "Algeria",
  },
  "American Samoa": {
    Code: "AS",
    Name: "American Samoa",
  },
  Andorra: {
    Code: "AD",
    Name: "Andorra",
  },
  Angola: {
    Code: "AO",
    Name: "Angola",
  },
  Anguilla: {
    Code: "AI",
    Name: "Anguilla",
  },
  Antarctica: {
    Code: "AQ",
    Name: "Antarctica",
  },
  "Antigua and Barbuda": {
    Code: "AG",
    Name: "Antigua and Barbuda",
  },
  Argentina: {
    Code: "AR",
    Name: "Argentina",
  },
  Armenia: {
    Code: "AM",
    Name: "Armenia",
  },
  Aruba: {
    Code: "AW",
    Name: "Aruba",
  },
  Australia: {
    Code: "AU",
    Name: "Australia",
  },
  Austria: {
    Code: "AT",
    Name: "Austria",
  },
  Azerbaijan: {
    Code: "AZ",
    Name: "Azerbaijan",
  },
  Bahamas: {
    Code: "BS",
    Name: "Bahamas",
  },
  Bahrain: {
    Code: "BH",
    Name: "Bahrain",
  },
  Bangladesh: {
    Code: "BD",
    Name: "Bangladesh",
  },
  Barbados: {
    Code: "BB",
    Name: "Barbados",
  },
  Belarus: {
    Code: "BY",
    Name: "Belarus",
  },
  Belgium: {
    Code: "BE",
    Name: "Belgium",
  },
  Belize: {
    Code: "BZ",
    Name: "Belize",
  },
  Benin: {
    Code: "BJ",
    Name: "Benin",
  },
  Bermuda: {
    Code: "BM",
    Name: "Bermuda",
  },
  Bhutan: {
    Code: "BT",
    Name: "Bhutan",
  },
  "Bolivia, Plurinational State of": {
    Code: "BO",
    Name: "Bolivia, Plurinational State of",
  },
  "Bonaire, Sint Eustatius and Saba": {
    Code: "BQ",
    Name: "Bonaire, Sint Eustatius and Saba",
  },
  "Bosnia and Herzegovina": {
    Code: "BA",
    Name: "Bosnia and Herzegovina",
  },
  Botswana: {
    Code: "BW",
    Name: "Botswana",
  },
  "Bouvet Island": {
    Code: "BV",
    Name: "Bouvet Island",
  },
  Brazil: {
    Code: "BR",
    Name: "Brazil",
  },
  "British Indian Ocean Territory": {
    Code: "IO",
    Name: "British Indian Ocean Territory",
  },
  "Brunei Darussalam": {
    Code: "BN",
    Name: "Brunei Darussalam",
  },
  Bulgaria: {
    Code: "BG",
    Name: "Bulgaria",
  },
  "Burkina Faso": {
    Code: "BF",
    Name: "Burkina Faso",
  },
  Burundi: {
    Code: "BI",
    Name: "Burundi",
  },
  Cambodia: {
    Code: "KH",
    Name: "Cambodia",
  },
  Cameroon: {
    Code: "CM",
    Name: "Cameroon",
  },
  Canada: {
    Code: "CA",
    Name: "Canada",
  },
  "Cape Verde": {
    Code: "CV",
    Name: "Cape Verde",
  },
  "Cayman Islands": {
    Code: "KY",
    Name: "Cayman Islands",
  },
  "Central African Republic": {
    Code: "CF",
    Name: "Central African Republic",
  },
  Chad: {
    Code: "TD",
    Name: "Chad",
  },
  Chile: {
    Code: "CL",
    Name: "Chile",
  },
  China: {
    Code: "CN",
    Name: "China",
  },
  "Christmas Island": {
    Code: "CX",
    Name: "Christmas Island",
  },
  "Cocos (Keeling) Islands": {
    Code: "CC",
    Name: "Cocos (Keeling) Islands",
  },
  Colombia: {
    Code: "CO",
    Name: "Colombia",
  },
  Comoros: {
    Code: "KM",
    Name: "Comoros",
  },
  Congo: {
    Code: "CG",
    Name: "Congo",
  },
  "Congo, the Democratic Republic of the": {
    Code: "CD",
    Name: "Congo, the Democratic Republic of the",
  },
  "Cook Islands": {
    Code: "CK",
    Name: "Cook Islands",
  },
  "Costa Rica": {
    Code: "CR",
    Name: "Costa Rica",
  },
  "Côte d'Ivoire": {
    Code: "CI",
    Name: "Côte d'Ivoire",
  },
  Croatia: {
    Code: "HR",
    Name: "Croatia",
  },
  Cuba: {
    Code: "CU",
    Name: "Cuba",
  },
  Curaçao: {
    Code: "CW",
    Name: "Curaçao",
  },
  Cyprus: {
    Code: "CY",
    Name: "Cyprus",
  },
  "Czech Republic": {
    Code: "CZ",
    Name: "Czech Republic",
  },
  Denmark: {
    Code: "DK",
    Name: "Denmark",
  },
  Djibouti: {
    Code: "DJ",
    Name: "Djibouti",
  },
  Dominica: {
    Code: "DM",
    Name: "Dominica",
  },
  "Dominican Republic": {
    Code: "DO",
    Name: "Dominican Republic",
  },
  Ecuador: {
    Code: "EC",
    Name: "Ecuador",
  },
  Egypt: {
    Code: "EG",
    Name: "Egypt",
  },
  "El Salvador": {
    Code: "SV",
    Name: "El Salvador",
  },
  "Equatorial Guinea": {
    Code: "GQ",
    Name: "Equatorial Guinea",
  },
  Eritrea: {
    Code: "ER",
    Name: "Eritrea",
  },
  Estonia: {
    Code: "EE",
    Name: "Estonia",
  },
  Ethiopia: {
    Code: "ET",
    Name: "Ethiopia",
  },
  "Falkland Islands (Malvinas)": {
    Code: "FK",
    Name: "Falkland Islands (Malvinas)",
  },
  "Faroe Islands": {
    Code: "FO",
    Name: "Faroe Islands",
  },
  Fiji: {
    Code: "FJ",
    Name: "Fiji",
  },
  Finland: {
    Code: "FI",
    Name: "Finland",
  },
  France: {
    Code: "FR",
    Name: "France",
  },
  "French Guiana": {
    Code: "GF",
    Name: "French Guiana",
  },
  "French Polynesia": {
    Code: "PF",
    Name: "French Polynesia",
  },
  "French Southern Territories": {
    Code: "TF",
    Name: "French Southern Territories",
  },
  Gabon: {
    Code: "GA",
    Name: "Gabon",
  },
  Gambia: {
    Code: "GM",
    Name: "Gambia",
  },
  Georgia: {
    Code: "GE",
    Name: "Georgia",
  },
  Germany: {
    Code: "DE",
    Name: "Germany",
  },
  Ghana: {
    Code: "GH",
    Name: "Ghana",
  },
  Gibraltar: {
    Code: "GI",
    Name: "Gibraltar",
  },
  Greece: {
    Code: "GR",
    Name: "Greece",
  },
  Greenland: {
    Code: "GL",
    Name: "Greenland",
  },
  Grenada: {
    Code: "GD",
    Name: "Grenada",
  },
  Guadeloupe: {
    Code: "GP",
    Name: "Guadeloupe",
  },
  Guam: {
    Code: "GU",
    Name: "Guam",
  },
  Guatemala: {
    Code: "GT",
    Name: "Guatemala",
  },
  Guernsey: {
    Code: "GG",
    Name: "Guernsey",
  },
  Guinea: {
    Code: "GN",
    Name: "Guinea",
  },
  "Guinea-Bissau": {
    Code: "GW",
    Name: "Guinea-Bissau",
  },
  Guyana: {
    Code: "GY",
    Name: "Guyana",
  },
  Haiti: {
    Code: "HT",
    Name: "Haiti",
  },
  "Heard Island and McDonald Islands": {
    Code: "HM",
    Name: "Heard Island and McDonald Islands",
  },
  "Holy See (Vatican City State)": {
    Code: "VA",
    Name: "Holy See (Vatican City State)",
  },
  Honduras: {
    Code: "HN",
    Name: "Honduras",
  },
  "Hong Kong": {
    Code: "HK",
    Name: "Hong Kong",
  },
  Hungary: {
    Code: "HU",
    Name: "Hungary",
  },
  Iceland: {
    Code: "IS",
    Name: "Iceland",
  },
  India: {
    Code: "IN",
    Name: "India",
  },
  Indonesia: {
    Code: "ID",
    Name: "Indonesia",
  },
  "Iran, Islamic Republic of": {
    Code: "IR",
    Name: "Iran, Islamic Republic of",
  },
  Iraq: {
    Code: "IQ",
    Name: "Iraq",
  },
  Ireland: {
    Code: "IE",
    Name: "Ireland",
  },
  "Isle of Man": {
    Code: "IM",
    Name: "Isle of Man",
  },
  Israel: {
    Code: "IL",
    Name: "Israel",
  },
  Italy: {
    Code: "IT",
    Name: "Italy",
  },
  Jamaica: {
    Code: "JM",
    Name: "Jamaica",
  },
  Japan: {
    Code: "JP",
    Name: "Japan",
  },
  Jersey: {
    Code: "JE",
    Name: "Jersey",
  },
  Jordan: {
    Code: "JO",
    Name: "Jordan",
  },
  Kazakhstan: {
    Code: "KZ",
    Name: "Kazakhstan",
  },
  Kenya: {
    Code: "KE",
    Name: "Kenya",
  },
  Kiribati: {
    Code: "KI",
    Name: "Kiribati",
  },
  "Democratic People's Republic of Korea (North)": {
    Code: "KP",
    Name: "Democratic People's Republic of Korea (North)",
  },
  "Republic of Korea (South)": {
    Code: "KR",
    Name: "Republic of Korea (South)",
  },
  "South Korea": {
    Code: "KR",
    Name: "Republic of Korea (South)",
  },
  Kuwait: {
    Code: "KW",
    Name: "Kuwait",
  },
  Kyrgyzstan: {
    Code: "KG",
    Name: "Kyrgyzstan",
  },
  "Lao People's Democratic Republic": {
    Code: "LA",
    Name: "Lao People's Democratic Republic",
  },
  Latvia: {
    Code: "LV",
    Name: "Latvia",
  },
  Lebanon: {
    Code: "LB",
    Name: "Lebanon",
  },
  Lesotho: {
    Code: "LS",
    Name: "Lesotho",
  },
  Liberia: {
    Code: "LR",
    Name: "Liberia",
  },
  Libya: {
    Code: "LY",
    Name: "Libya",
  },
  Liechtenstein: {
    Code: "LI",
    Name: "Liechtenstein",
  },
  Lithuania: {
    Code: "LT",
    Name: "Lithuania",
  },
  Luxembourg: {
    Code: "LU",
    Name: "Luxembourg",
  },
  Macao: {
    Code: "MO",
    Name: "Macao",
  },
  "Macedonia, the Former Yugoslav Republic of": {
    Code: "MK",
    Name: "Macedonia, the Former Yugoslav Republic of",
  },
  Madagascar: {
    Code: "MG",
    Name: "Madagascar",
  },
  Malawi: {
    Code: "MW",
    Name: "Malawi",
  },
  Malaysia: {
    Code: "MY",
    Name: "Malaysia",
  },
  Maldives: {
    Code: "MV",
    Name: "Maldives",
  },
  Mali: {
    Code: "ML",
    Name: "Mali",
  },
  Malta: {
    Code: "MT",
    Name: "Malta",
  },
  "Marshall Islands": {
    Code: "MH",
    Name: "Marshall Islands",
  },
  Martinique: {
    Code: "MQ",
    Name: "Martinique",
  },
  Mauritania: {
    Code: "MR",
    Name: "Mauritania",
  },
  Mauritius: {
    Code: "MU",
    Name: "Mauritius",
  },
  Mayotte: {
    Code: "YT",
    Name: "Mayotte",
  },
  Mexico: {
    Code: "MX",
    Name: "Mexico",
  },
  "Micronesia, Federated States of": {
    Code: "FM",
    Name: "Micronesia, Federated States of",
  },
  "Moldova, Republic of": {
    Code: "MD",
    Name: "Moldova, Republic of",
  },
  Monaco: {
    Code: "MC",
    Name: "Monaco",
  },
  Mongolia: {
    Code: "MN",
    Name: "Mongolia",
  },
  Montenegro: {
    Code: "ME",
    Name: "Montenegro",
  },
  Montserrat: {
    Code: "MS",
    Name: "Montserrat",
  },
  Morocco: {
    Code: "MA",
    Name: "Morocco",
  },
  Mozambique: {
    Code: "MZ",
    Name: "Mozambique",
  },
  "Myanmar (Burma)": {
    Code: "MM",
    Name: "Myanmar (Burma)",
  },
  Namibia: {
    Code: "NA",
    Name: "Namibia",
  },
  Nauru: {
    Code: "NR",
    Name: "Nauru",
  },
  Nepal: {
    Code: "NP",
    Name: "Nepal",
  },
  Netherlands: {
    Code: "NL",
    Name: "Netherlands",
  },
  "New Caledonia": {
    Code: "NC",
    Name: "New Caledonia",
  },
  "New Zealand": {
    Code: "NZ",
    Name: "New Zealand",
  },
  Nicaragua: {
    Code: "NI",
    Name: "Nicaragua",
  },
  Niger: {
    Code: "NE",
    Name: "Niger",
  },
  Nigeria: {
    Code: "NG",
    Name: "Nigeria",
  },
  Niue: {
    Code: "NU",
    Name: "Niue",
  },
  "Norfolk Island": {
    Code: "NF",
    Name: "Norfolk Island",
  },
  "Northern Mariana Islands": {
    Code: "MP",
    Name: "Northern Mariana Islands",
  },
  Norway: {
    Code: "NO",
    Name: "Norway",
  },
  Oman: {
    Code: "OM",
    Name: "Oman",
  },
  Pakistan: {
    Code: "PK",
    Name: "Pakistan",
  },
  Palau: {
    Code: "PW",
    Name: "Palau",
  },
  "Palestine, State of": {
    Code: "PS",
    Name: "Palestine, State of",
  },
  Panama: {
    Code: "PA",
    Name: "Panama",
  },
  "Papua New Guinea": {
    Code: "PG",
    Name: "Papua New Guinea",
  },
  Paraguay: {
    Code: "PY",
    Name: "Paraguay",
  },
  Peru: {
    Code: "PE",
    Name: "Peru",
  },
  Philippines: {
    Code: "PH",
    Name: "Philippines",
  },
  Pitcairn: {
    Code: "PN",
    Name: "Pitcairn",
  },
  Poland: {
    Code: "PL",
    Name: "Poland",
  },
  Portugal: {
    Code: "PT",
    Name: "Portugal",
  },
  "Puerto Rico": {
    Code: "PR",
    Name: "Puerto Rico",
  },
  Qatar: {
    Code: "QA",
    Name: "Qatar",
  },
  Réunion: {
    Code: "RE",
    Name: "Réunion",
  },
  Romania: {
    Code: "RO",
    Name: "Romania",
  },
  "Russian Federation": {
    Code: "RU",
    Name: "Russian Federation",
  },
  Rwanda: {
    Code: "RW",
    Name: "Rwanda",
  },
  "Saint Barthélemy": {
    Code: "BL",
    Name: "Saint Barthélemy",
  },
  "Saint Helena, Ascension and Tristan da Cunha": {
    Code: "SH",
    Name: "Saint Helena, Ascension and Tristan da Cunha",
  },
  "Saint Kitts and Nevis": {
    Code: "KN",
    Name: "Saint Kitts and Nevis",
  },
  "Saint Lucia": {
    Code: "LC",
    Name: "Saint Lucia",
  },
  "Saint Martin (French part)": {
    Code: "MF",
    Name: "Saint Martin (French part)",
  },
  "Saint Pierre and Miquelon": {
    Code: "PM",
    Name: "Saint Pierre and Miquelon",
  },
  "Saint Vincent and the Grenadines": {
    Code: "VC",
    Name: "Saint Vincent and the Grenadines",
  },
  Samoa: {
    Code: "WS",
    Name: "Samoa",
  },
  "San Marino": {
    Code: "SM",
    Name: "San Marino",
  },
  "Sao Tome and Principe": {
    Code: "ST",
    Name: "Sao Tome and Principe",
  },
  "Saudi Arabia": {
    Code: "SA",
    Name: "Saudi Arabia",
  },
  Senegal: {
    Code: "SN",
    Name: "Senegal",
  },
  Serbia: {
    Code: "RS",
    Name: "Serbia",
  },
  Seychelles: {
    Code: "SC",
    Name: "Seychelles",
  },
  "Sierra Leone": {
    Code: "SL",
    Name: "Sierra Leone",
  },
  Singapore: {
    Code: "SG",
    Name: "Singapore",
  },
  "Sint Maarten (Dutch part)": {
    Code: "SX",
    Name: "Sint Maarten (Dutch part)",
  },
  Slovakia: {
    Code: "SK",
    Name: "Slovakia",
  },
  Slovenia: {
    Code: "SI",
    Name: "Slovenia",
  },
  "Solomon Islands": {
    Code: "SB",
    Name: "Solomon Islands",
  },
  Somalia: {
    Code: "SO",
    Name: "Somalia",
  },
  "South Africa": {
    Code: "ZA",
    Name: "South Africa",
  },
  "South Georgia and the South Sandwich Islands": {
    Code: "GS",
    Name: "South Georgia and the South Sandwich Islands",
  },
  "South Sudan": {
    Code: "SS",
    Name: "South Sudan",
  },
  Spain: {
    Code: "ES",
    Name: "Spain",
  },
  "Sri Lanka": {
    Code: "LK",
    Name: "Sri Lanka",
  },
  Sudan: {
    Code: "SD",
    Name: "Sudan",
  },
  Suriname: {
    Code: "SR",
    Name: "Suriname",
  },
  "Svalbard and Jan Mayen": {
    Code: "SJ",
    Name: "Svalbard and Jan Mayen",
  },
  Swaziland: {
    Code: "SZ",
    Name: "Swaziland",
  },
  Sweden: {
    Code: "SE",
    Name: "Sweden",
  },
  Switzerland: {
    Code: "CH",
    Name: "Switzerland",
  },
  "Syrian Arab Republic": {
    Code: "SY",
    Name: "Syrian Arab Republic",
  },
  "Taiwan, Province of China": {
    Code: "TW",
    Name: "Taiwan, Province of China",
  },
  Tajikistan: {
    Code: "TJ",
    Name: "Tajikistan",
  },
  "Tanzania, United Republic of": {
    Code: "TZ",
    Name: "Tanzania, United Republic of",
  },
  Thailand: {
    Code: "TH",
    Name: "Thailand",
  },
  "Timor-Leste": {
    Code: "TL",
    Name: "Timor-Leste",
  },
  Togo: {
    Code: "TG",
    Name: "Togo",
  },
  Tokelau: {
    Code: "TK",
    Name: "Tokelau",
  },
  Tonga: {
    Code: "TO",
    Name: "Tonga",
  },
  "Trinidad and Tobago": {
    Code: "TT",
    Name: "Trinidad and Tobago",
  },
  Tunisia: {
    Code: "TN",
    Name: "Tunisia",
  },
  Turkey: {
    Code: "TR",
    Name: "Turkey",
  },
  Turkmenistan: {
    Code: "TM",
    Name: "Turkmenistan",
  },
  "Turks and Caicos Islands": {
    Code: "TC",
    Name: "Turks and Caicos Islands",
  },
  Tuvalu: {
    Code: "TV",
    Name: "Tuvalu",
  },
  Uganda: {
    Code: "UG",
    Name: "Uganda",
  },
  Ukraine: {
    Code: "UA",
    Name: "Ukraine",
  },
  "United Arab Emirates": {
    Code: "AE",
    Name: "United Arab Emirates",
  },
  "United Kingdom": {
    Code: "GB",
    Name: "United Kingdom",
  },
  "United States of America": {
    Code: "US",
    Name: "United States of America",
  },
  "United States Minor Outlying Islands": {
    Code: "UM",
    Name: "United States Minor Outlying Islands",
  },
  Uruguay: {
    Code: "UY",
    Name: "Uruguay",
  },
  Uzbekistan: {
    Code: "UZ",
    Name: "Uzbekistan",
  },
  Vanuatu: {
    Code: "VU",
    Name: "Vanuatu",
  },
  "Venezuela, Bolivarian Republic of": {
    Code: "VE",
    Name: "Venezuela, Bolivarian Republic of",
  },
  Vietnam: {
    Code: "VN",
    Name: "Vietnam",
  },
  "Virgin Islands, British": {
    Code: "VG",
    Name: "Virgin Islands, British",
  },
  "Virgin Islands, U.S.": {
    Code: "VI",
    Name: "Virgin Islands, U.S.",
  },
  "Wallis and Futuna": {
    Code: "WF",
    Name: "Wallis and Futuna",
  },
  "Western Sahara": {
    Code: "EH",
    Name: "Western Sahara",
  },
  Yemen: {
    Code: "YE",
    Name: "Yemen",
  },
  Zambia: {
    Code: "ZM",
    Name: "Zambia",
  },
  Zimbabwe: {
    Code: "ZW",
    Name: "Zimbabwe",
  },
};

export default isoMap;
